import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProcessFlow } from '../masterdata/models/processFlow';

@Component({
  selector: 'app-ma-preparation',
  templateUrl: './ma-preparation.component.html'
})
export class MaPreparationComponent implements OnInit {

  blocked = false;
  index: number = 0;
  is96MergeOn = true;
  selectedProcessFlows: ProcessFlow[];
  qcScanTabActive: boolean = false;
  extractionTabActive: boolean = false;
  mergeTabActive: boolean = false;
  scannedPlateID: string;
  constructor(private activatedroute: ActivatedRoute) { }

  ngOnInit() {
    this.updateSelectedProcessFlowProperties();
    this.activatedroute.params.subscribe(
      params => {
         this.scannedPlateID = params['id'];
         let tabIndex = params['tab'];
         if(this.scannedPlateID && tabIndex) {
          this.onTabChange({index : +tabIndex});
        }
      }
   );
  }
  
  onTabChange(event) {
    switch (event.index) {
      case 0: // QC-Scan
        this.qcScanTabActive = true;
        this.extractionTabActive = false;
        this.mergeTabActive = false;
        break;
      case 1: // Extraction
        this.qcScanTabActive = false;
        this.extractionTabActive = true;
        this.mergeTabActive = false;
        break;
      case 2: // Merge
        this.qcScanTabActive = false;
        this.extractionTabActive = false;
        this.mergeTabActive = true;
        break;
      default:
        break;
    }
    this.index = event.index;
  }

  updateSelectedProcessFlowProperties(){
    this.selectedProcessFlows = JSON.parse(localStorage.getItem('selectedProcessFlows'));
    this.is96MergeOn = false;
    for(let i=0; i<this.selectedProcessFlows.length; i++){
      if(this.selectedProcessFlows[i].merge96){
        this.is96MergeOn = true;
        break
      }
    }
    return true
  }

  getCSSClassForPanel(index: number){
    if(index == this.index){
      return 'selected';
    }else{
      return 'unselected';
    }
  }
}
